import { render } from "./BackToTopBtn.vue?vue&type=template&id=37ba8898"
import script from "./BackToTopBtn.vue?vue&type=script&lang=js"
export * from "./BackToTopBtn.vue?vue&type=script&lang=js"

import "./BackToTopBtn.vue?vue&type=style&index=0&id=37ba8898&lang=scss"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__